<h1 mat-dialog-title>Reset?</h1>
<div mat-dialog-content>
  <p>Are you sure you want to reset the app and delete all data?</p>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false">No thanks</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Yes, reset</button>
</div>
